/*
 * @Author: Code-HHX
 * @Date: 2022-04-19 10:32:17
 * @LastEditors: Code-HHX
 * @LastEditTime: 2022-04-19 14:43:15
 * @Description:常用工具类
 */

//验证变量是否为空
export function isNullAndEmpty(obj) {
  if (typeof obj == "string") {
    obj = obj.trim();
  }
  if (obj === null || obj === "" || obj === undefined || obj === "null") {
    return true;
  } else {
    return false;
  }
}

//验证邮箱格式
export function isEmail(str) {
  var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
  return reg.test(str);
}


export function voltageNumber(brandId, deviceId) {
  if (brandId === 2) {
    const supportDeviceIds = [0x49, 0x59, 0x67, 0x69, 0x72, 0x73, 0x7A, 0x7D,0x8a];

    if (supportDeviceIds.includes(deviceId)) {
      return 8;
    }
  }
  return 6;
}

export function isBtDeviceSupportLevel(brandId, deviceId) {
  if (brandId === 2) {
    const supportDeviceIds = [
      0x11,
      0x12,
      0x13,
      0x03,
      0x15,
      0x19,
      0x21,
      0x24,
      0x28,
      0x31,
      0x35,
      0x36,
      0x3A,
      0x3D,
      0x43,
      0x44,
      0x45,
      0x51,
      0x54,
      0x63,
      0x70,
      0x77,
      0x7F,
      0x81,
      0x87,

    ];
    if (supportDeviceIds.includes(deviceId)) {
      return true;
    }
  } else if (brandId === 3) {
    const supportDeviceIds = [0x0a];
    if (supportDeviceIds.includes(deviceId)) {
      return true;
    }
  }
  return false;
}

export function isBtDeviceSupportOutputDuration(brandId, deviceId) {
  if (brandId === 2) {
    const supportDeviceIds = [
      12,
      0x10,
      0x11,
      0x12,
      0x13,
      0x14,
      0x15,
      0x16,
      0x17,
      0x18,
      0x19,
      0x20,
      0x21,
      0x22,
      0x23,
      0x24,
      0x25,
      0x26,
      0x27,
      0x28,
      0x31,
      0x32,
      0x33,
      0x34,
      0x35,
      0x36,
      0x37,
      0x38,
      0x39,
      0x3A,
      0x3B,
      0x3C,
      0x3D,
      0x3E,
      0x3F,
      0x40,
      0x41,
      0x42,
      0x43,
      0x44,
      0x45,
      0x46,
      0x47,
      0x48,
      0x49,
      0x50,
      0x51,
      0x52,
      0x53,
      0x54,
      0x55,
      0x56,
      0x57,
      0x58,
      0x59,
      0x60,
      0x61,
      0x62,
      0x63,
      0x64,
      0x65,
      0x66,
      0x67,
      0x68,
      0x69,
      0x70,
      0x71,
      0x72,
      0x73,
      0x74,
      0x75,
      0x76,
      0x77,
      0x78,
      0x79,
      0x7A,
      0x7B,
      0x7C,
      0x7D,
      0x7E,
      0x7F,
      0x80,
      0x81,
      0x82,
      0x83,
      0x84,
      0x85,
      0x86,
      0x87,
      0x88,
      0x89,
      0x8a,
      0x8b,
      0x8c,
      0x8d,
      0x8e,
      0x8f,
      0x90,
    ];
    if (supportDeviceIds.includes(deviceId)) {
      return true;
    }
  } else if (brandId === 3) {
    const supportDeviceIds = [8, 9, 0x0a, 0x0b, 0x0c, 0x0d];
    return supportDeviceIds.includes(deviceId);
  } else if (brandId === 5) {
    const supportDeviceIds = [1, 2];
    return supportDeviceIds.includes(deviceId);
  }
  return false;
}

export function isSupportDoubleCartridge(brandId, deviceId) {
  if (brandId === 2) {
    const supportDeviceIds = [0x33, 0x37, 0x38, 0x3B,
      0x3C, 0x3E, 0x3F, 0x41, 0x43, 0x46, 0x47, 0x49,
      0x52, 0x55,0x56, 0x57, 0x59, 0x75, 0x76, 0x78,
      0x7A, 0x7C, 0x82, 0x83, 0x85,0x86,0x88,0x89,0x8d,0x8e,0x8f];
    if (supportDeviceIds.includes(deviceId)) {
      return true;
    }
  } else if (brandId === 5) {
    return false;
  }

  return false;
}

export function excludeDeviceDoubleCartridge(brandId, deviceId) {
  if (brandId === 2) {
    const supportDeviceIds = [0x3B, 0x3C, 0x3F, 0x41,  0x76, 0x7C];
    if (supportDeviceIds.includes(deviceId)) {
      return true;
    }
  } else if (brandId === 5) {
    return false;
  }

  return false;
}

export function excludeSwitchMode(brandId, deviceId) {
  if (brandId === 2) {
    const supportDeviceIds = [0x3B, 0x3C, 0x41, 0x46, 0x47, 0x52, 0x76, 0x78, 0x7C];
    if (supportDeviceIds.includes(deviceId)) {
      return true;
    }
  } else if (brandId === 5) {
    return false;
  }

  return false;
}

export function getDeviceSupportLevelList(brandId, deviceId) {
  if (brandId === 2) {
    const supportLevel6DeviceIds = [0x25];
    const supportLevel4DeviceIds = [0x70];

    const supportLevel2DeviceIds = [
      0x11,
      0x12,
      0x13,
      0x15,
      0x21,
      0x31,
      0x35,
      0x36,
      0x3A,
      0x3D,
      0x43,
      0x44,
      0x54,
      0x63,
      0x77,
      0x87,
    ];
    if (supportLevel6DeviceIds.includes(deviceId)) {
      return [
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 }
      ];
    } else if (supportLevel2DeviceIds.includes(deviceId)) {
      return [
        { text: "1", value: 1 },
        { text: "2", value: 2 }
      ];
    } else if (supportLevel4DeviceIds.includes(deviceId)) {
      return [
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 }
      ];
    } else {
      return [
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 }
      ];
    }
  }
  return [
    { text: "1", value: 1 },
    { text: "2", value: 2 },
    { text: "3", value: 3 }
  ];
}

export function isSupportSwitchMode(brandId, deviceId) {
  if (brandId === 5 && (deviceId === 1 || deviceId === 2)) {
    return true;
  } else if (brandId === 2) {
    const supportDeviceIds = [0x37, 0x38, 0x39, 0x41, 0x46, 0x52];
    if (supportDeviceIds.includes(deviceId)) {
      return true;
    }
  }
  return false;
}

export function isSupportSwitchModeSpecial(brandId, deviceId) {
  if (brandId === 5 && (deviceId === 1 || deviceId === 2)) {
    return true;
  }
  return false;
}

export function isSupportTripleCartridge(brandId, deviceId) {
  if (brandId === 2 && ((deviceId === 0x39) || deviceId === 0x72 || deviceId === 0x73 || deviceId === 0x42 || deviceId === 0x67 || deviceId === 0x69 || deviceId === 0x7d || deviceId === 0x84|| deviceId === 0x8a)) {
    return true;
  }
  return false;
}